@if (form) {
  <ul>
    @if (!oldForm || form.name !== oldForm.name) {<li>Name: {{form.name}}</li>}
    @if (!oldForm || form.groupName !== oldForm.groupName) {<li>Kategorie: {{form.groupName}}</li>}
    @if (!oldForm || !isEqual(form.visibleForGroups, oldForm.visibleForGroups)) {<li>AD-Gruppen Beschränkung: {{form.visibleForGroups?.length ? form.visibleForGroups?.join(', ') : '--'}}</li>}
    @if (!oldForm || !isEqual(form.owners, oldForm.owners)) {<li>Verantwortliche: {{userListToString(owners)}}</li>}
    @if (!oldForm || !isEqual(form.operators, oldForm.operators)) {<li>Bearbeiter/innen: {{userListToString(operators)}}</li>}
    @if (!oldForm || !isEqual(form.readers, oldForm.readers)) {<li>Leser/innen: {{userListToString(readers)}}</li>}
    @if (!oldForm || !isEqual(form.tester, oldForm.tester)) {<li>Tester/innen: {{userListToString(tester)}}</li>}
    @if (!oldForm || form.showLastOperator !== oldForm.showLastOperator) {<li>Letzte/n Bearbeiter/in im Antrag anzeigen: {{form.showLastOperator ? 'Ja' : 'Nein'}}</li>}
    @if (!oldForm || form.allowCancelUntilProgressStarts !== oldForm.allowCancelUntilProgressStarts) {<li>Erlaube Stornierung bis zum Bearbeitungsbeginn: {{form.allowCancelUntilProgressStarts ? 'Ja' : 'Nein'}}</li>}
    @if (!oldForm || form.visible !== oldForm.visible) {<li>Sichtbarkeit: {{form.visible ? 'veröffentlicht' : 'nicht veröffentlicht'}}</li>}
    @if (!oldForm || form.orgUnitType !== oldForm.orgUnitType || form.orgUnitName !== oldForm.orgUnitName) {<li>Fachabteilung: {{form.orgUnitType === OrgUnitType.MAIN_DEPARTMENT ? 'Hauptabteilung' : 'Abteilung'}} {{form.orgUnitName}}</li>}
    @if (!oldForm || form.contactEmail !== oldForm.contactEmail) {<li>E-Mail: {{form.contactEmail}}</li>}
    @if (!oldForm || form.contactTelephone !== oldForm.contactTelephone) {<li>Telefonnummer: {{form.contactTelephone}}</li>}
    @if (!oldForm || form.storagePeriod !== oldForm.storagePeriod) {<li>Speicherdauer: {{form.storagePeriod}} Jahre</li>}
    @if (!oldForm || !isEqual(form.approverTypes, oldForm.approverTypes)) {
      <li>
        Genehmigungsweg: {{form.approverTypes?.length}} {{form.approverTypes?.length === 1 ? 'Genehmigungsstufe' : 'Genehmigungsstufen'}}
        <ul>
          @for (approverType of form.approverTypes; track approverType) {
            <li>{{getLocalizedNameOfApproverType(approverType)}}</li>
          }
        </ul>
      </li>
    }
    @for (approverData of form.approverDataCustomParameter; track approverData; let i = $index) {
      @if (form.approverTypes?.[i] === ApproverType.DESIGNATED_APPROVER) {
        @if (!oldForm || !isEqual(approverData.users, oldForm.approverDataCustomParameter?.[i]?.users)) {<li>{{i+1}}. Genehmigungsstufe - Genehmiger/in: {{userListToString(approverData.users)}}</li>}
        @if (!oldForm || !isEqual(approverData.deputyUsers, oldForm.approverDataCustomParameter?.[i]?.deputyUsers)) {<li>{{i+1}}. Genehmigungsstufe - Vertreter/in: {{userListToString(approverData.deputyUsers)}}</li>}
      }
      @if (form.approverTypes?.[i] === ApproverType.APPROVER_GROUP) {
        @if (!oldForm || !isEqual(approverData.groupMembers, oldForm.approverDataCustomParameter?.[i]?.groupMembers)) {<li>{{i+1}}. Genehmigungsstufe - Gruppenmitglieder: {{userListToString(approverData.groupMembers)}}</li>}
        @if (!oldForm || approverData.mailNotification !== oldForm.approverDataCustomParameter?.[i]?.mailNotification) {<li>{{i+1}}. Genehmigungsstufe - Benachrichtigung: {{approverData.mailNotification ? 'Ja' : 'Nein'}}</li>}
      }
      @if (!oldForm || approverData.forInformationOnly !== oldForm.approverDataCustomParameter?.[i]?.forInformationOnly) {<li>{{i+1}}. Genehmigungsstufe - Zur Kenntnisnahme: {{approverData.forInformationOnly ? 'Ja' : 'Nein'}}</li>}
      @if (!oldForm || approverData.limit !== oldForm.approverDataCustomParameter?.[i]?.limit) {<li>{{i+1}}. Genehmigungsstufe - Genehmigungslimit: {{approverData.limit ?? '--'}}</li>}
    }
    @if (!oldForm || form.actionType !== oldForm.actionType) {
      <li>
        Vorgangstyp:
        @switch (form.actionType) {
          @default {
            Keine Weiterleitung
          }
          @case ('EMAIL') {
            E-Mail Benachrichtigung
          }
          @case ('EMAIL_DATA') {
            E-Mail Datenübermittlung
          }
          @case ('OTRS') {
            OTRS (EMAIL) Vorgang (nur für HA MIT)
          }
          @case ('OTRS_WEBSERVICE') {
            OTRS (WEB) Vorgang (nur für HA MIT)
          }
          @case ('WEBHOOK') {
            Webhook
          }
          @case ('NO') {
            Keine Bearbeitung oder Weiterleitung
          }
        }
      </li>
    }
    @if (form.actionType === ActionType.EMAIL || form.actionType === ActionType.EMAIL_DATA || form.actionType === ActionType.OTRS) {
      @if (!oldForm || form.actionDataCustomParameter?.emailAddress !== oldForm.actionDataCustomParameter?.emailAddress) {<li>Übermittlungsadresse: {{form.actionDataCustomParameter?.emailAddress ?? '--'}}</li>}
    }
    @if (form.actionType === ActionType.OTRS) {
      @if (!oldForm || form.actionDataCustomParameter?.subjectTag !== oldForm.actionDataCustomParameter?.subjectTag) {<li>Übermittlungswert: {{form.actionDataCustomParameter?.subjectTag ?? '--'}}</li>}
    }
    @if (form.actionType === ActionType.OTRS_WEBSERVICE) {
      @if (!oldForm || form.actionDataCustomParameter?.url !== oldForm.actionDataCustomParameter?.url) {<li>OTRS-Instanz: {{form.actionDataCustomParameter?.url ?? '--'}}</li>}
      @if (!oldForm || form.actionDataCustomParameter?.title !== oldForm.actionDataCustomParameter?.title) {<li>Ticket Titel: {{form.actionDataCustomParameter?.title ?? '--'}}</li>}
      @if (!oldForm || form.actionDataCustomParameter?.type !== oldForm.actionDataCustomParameter?.type) {<li>Typ: {{form.actionDataCustomParameter?.type ?? '--'}}</li>}
      @if (!oldForm || form.actionDataCustomParameter?.service !== oldForm.actionDataCustomParameter?.service) {<li>Service: {{form.actionDataCustomParameter?.service ?? '--'}}</li>}
      @if (!oldForm || form.actionDataCustomParameter?.queue !== oldForm.actionDataCustomParameter?.queue) {<li>Queue: {{form.actionDataCustomParameter?.queue ?? '--'}}</li>}
      @if (!oldForm || form.actionDataCustomParameter?.dynamicFields !== oldForm.actionDataCustomParameter?.dynamicFields) {<li>Dynamische Felder: {{form.actionDataCustomParameter?.dynamicFields ?? '--'}}</li>}
    }
    @if (form.actionType === ActionType.WEBHOOK) {
      @if (!oldForm || form.actionDataCustomParameter?.url !== oldForm.actionDataCustomParameter?.url) {<li>Webhook URL: {{form.actionDataCustomParameter?.url ?? '--'}}</li>}
      @if (!oldForm || form.actionDataCustomParameter?.title !== oldForm.actionDataCustomParameter?.token) {<li>Webhook Token: {{form.actionDataCustomParameter?.token ?? '--'}}</li>}
      @if (!oldForm || form.actionDataCustomParameter?.bearer !== oldForm.actionDataCustomParameter?.bearer) {<li>Webhook Bearer: {{form.actionDataCustomParameter?.bearer ?? '--'}}</li>}
    }
    @if (!oldForm || !isEqual(form.fields, oldForm.fields)) {<li>Formularfelder: {{form.fields?.length}} {{form.fields?.length === 1 ? 'Feld' : 'Felder'}} @if (oldForm?.fields) { (Vorher {{oldForm?.fields?.length}}; Änderungen gelb markiert) }</li>}
    @if (!oldForm || form.privacyReason !== oldForm.privacyReason) {<li>Zweck der Datenverarbeitung: {{form.privacyReason ?? '--'}}</li>}
    @if (!oldForm || !isEqual(form.dataFields, oldForm.dataFields)) {
      <li>
        Datenfelder:
        @if (form.dataFieldsCustomParameter?.length) {
          <ul>
            @for (dataField of form.dataFieldsCustomParameter; track dataField) {
              <li>{{dataField}}</li>
            }
          </ul>
        } @else {
          --
        }
      </li>
    }
    @if (!oldForm || form.legalBasis !== oldForm.legalBasis) {<li>Rechtsgrundlage: {{form.legalBasis ?? '--'}}</li>}
    @if (!oldForm || form.dataTransmission !== oldForm.dataTransmission) {<li>Datenweitergabe: {{form.dataTransmission ?? '--'}}</li>}
    @if (!oldForm || form.externalDataTransmission !== oldForm.externalDataTransmission) {<li>Externe Datenweitergabe: {{form.externalDataTransmission ?? '--'}}</li>}
  </ul>
}
